export default "assets/images/icons/arrow-02b6b5e2.svg";